import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { QRCodeSVG } from 'qrcode.react';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import Button from '../../components/Button';
import SimpleFooter from '../../components/SimpleFooter';
import SimpleHeader from '../../components/SimpleHeader';
import styles from './login.module.scss';
import './login.scss';

export default function TwoFactorSetup(props) {
    const history = useHistory();
    const location = useLocation();

    // Get QR code URI and secret from location state (passed from Login)
    const uri = location.state?.uri;
    const secret = location.state?.secret;
    const sessionData = location.state?.sessionData;
    const username = location.state?.username;
    const password = location.state?.password;
    const rememberMe = location.state?.rememberMe;

    // Note: We don't redirect immediately if data is missing
    // to allow time for the location state to be populated
    // The page will show "Loading QR Code..." if data is not available

    const handleContinue = () => {
        // Navigate to OTP verification page with session data and credentials
        history.push({
            pathname: '/verify-2fa',
            state: {
                sessionData,
                username,
                password,
                rememberMe
            }
        });
    };

    const handleUseSecretKey = () => {
        // Navigate to secret key page
        history.push({
            pathname: '/secret-key-2fa',
            state: {
                uri,
                secret,
                sessionData,
                username,
                password,
                rememberMe
            }
        });
    };

    return (
        <div className='h-100 login-page'>
            <SimpleHeader />
            <Container>
                <ContentBox>
                    <Title>Access your authenticator app</Title>
                    <Subtitle>
                        Scan the QR Code from your authenticator app to get a access code.
                    </Subtitle>

                    <QRCodeContainer>
                        {uri ? (
                            <QRCodeWrapper>
                                <QRCodeSVG value={uri} size={200} level="H" />
                            </QRCodeWrapper>
                        ) : (
                            <div>Loading QR Code...</div>
                        )}
                    </QRCodeContainer>

                    <InfoSection>
                        <AiOutlineInfoCircle size={20} color="#666" />
                        <InfoText>Having trouble scanning the QR code?</InfoText>
                        <SecretKeyLink onClick={handleUseSecretKey}>
                            Use the secret key instead.
                        </SecretKeyLink>
                    </InfoSection>

                    <Button
                        text='CONTINUE'
                        className={styles.loginBtn}
                        onClick={handleContinue}
                    />
                </ContentBox>
            </Container>
            <SimpleFooter {...props} />
        </div>
    );
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    background-color: #f5f5f5;
    height: 83vh;

    @media (max-width: 768px) {
        padding: 20px 15px;
    }
`;

const ContentBox = styled.div`
    padding: 40px 20px;
    max-width: 500px;
    width: 100%;
    text-align: center;

    @media (max-width: 768px) {
        padding: 20px 15px;
    }
`;

const Title = styled.h2`
    font-size: 24px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;

    @media (max-width: 768px) {
        font-size: 20px;
    }
`;

const Subtitle = styled.p`
    font-size: 14px;
    color: #666;
    margin-bottom: 30px;
    line-height: 1.5;

    @media (max-width: 768px) {
        font-size: 13px;
        margin-bottom: 20px;
    }
`;

const QRCodeContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 30px 0;
    min-height: 200px;

    @media (max-width: 768px) {
        margin: 20px 0;
        min-height: 150px;
    }
`;

const QRCodeWrapper = styled.div`
    padding: 20px;
    background: white;
    display: inline-block;

    svg {
        display: block;
        width: 200px !important;
        height: 200px !important;

        @media (max-width: 480px) {
            width: 180px !important;
            height: 180px !important;
        }

        @media (max-width: 360px) {
            width: 160px !important;
            height: 160px !important;
        }
    }

    @media (max-width: 768px) {
        padding: 15px;
    }
`;

const InfoSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
    margin: 20px 0;
    padding: 15px;

    @media (max-width: 768px) {
        font-size: 12px;
        padding: 10px;
    }
`;

const InfoText = styled.span`
    font-size: 13px;
    color: #666;

    @media (max-width: 768px) {
        font-size: 12px;
    }
`;

const SecretKeyLink = styled.span`
    font-size: 13px;
    color: #28a745;
    cursor: pointer;
    font-weight: 500;
    
    &:hover {
        text-decoration: underline;
    }

    @media (max-width: 768px) {
        font-size: 12px;
    }
`;